<template>
  <div class="invoice-item-editor">
    <div class="invoice-item-header">
      <div class="invoice-item-item">
        {{ $t('admin_acc_invoice.item') }}
      </div>
      <div class="invoice-item-unit-price">
        {{ $t('admin_acc_invoice.unit_price') }}
      </div>
      <div class="invoice-item-quantity">
        {{ $t('admin_acc_invoice.quantity') }}
      </div>
      <div class="invoice-item-subtotal">
        {{ $t('admin_acc_invoice.subtotal') }}
      </div>
      <div class="invoice-item-delete" v-if="!readonly"></div>
    </div>
    <div class="invoice-item-rows">
      <div class="invoice-item-row" v-for="(item, idx) in items">
        <div class="invoice-item-item">
          <v-text-field :outlined="!readonly"
                        :readonly="readonly"
                        v-model="item.item"
                        hide-details></v-text-field>
        </div>
        <div class="invoice-item-unit-price">
          <v-text-field :outlined="!readonly"
                        :readonly="readonly"
                        type="number"
                        step=".01"
                        v-model="item.unit_price"
                        hide-details></v-text-field>
        </div>
        <div class="invoice-item-quantity">
          <v-text-field :outlined="!readonly"
                        :readonly="readonly"
                        type="number"
                        step="1"
                        v-model="item.quantity"
                        hide-details></v-text-field>
        </div>
        <div class="invoice-item-subtotal">
          <v-text-field readonly
                        hide-details
                        :value="getSubtotal(item)"></v-text-field>
        </div>
        <div class="invoice-item-delete" v-if="!readonly">
          <v-btn icon
                 @click="removeItem(idx)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="invoice-item-row mt-2" v-if="!readonly">
        <v-col>
          <v-btn block
                 small
                 color="primary"
                 :disabled="!bookingIds || bookingIds.length === 0"
                 @click="generateItemsFromBookings">
            {{ $t('admin_acc_invoice.generate_from_bookings') }}
          </v-btn>
        </v-col>

        <v-col>
          <v-btn block
                 small
                 color="primary"
                 @click="addItem">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, watch} from "@vue/composition-api";

export default {
  name: 'InvoiceItemEditor',
  props: {
    value: {
      type: Array,
      default: () => {
        return [{}]
      },
    },
    purchaseOrderId: Number,
    bookingIds: Array,
    readonly: Boolean,
  },
  setup(props, {root, emit}) {
    const items = ref([]);
    const getSubtotal = function (item) {
      let unitPrice = parseFloat(item.unit_price) || 0;
      let quantity = parseInt(item.quantity) || 1;

      return unitPrice * quantity;
    }
    const addItem = function () {
      items.value = [
        ...items.value,
        {},
      ]
    }
    const generateItemsFromBookings = function () {
      if (props.bookingIds) {
        root.$callAPI('aafb/admin/purchase_order/generate_invoice_items/', {
          purchase_order_id: props.purchaseOrderId,
          booking_ids: props.bookingIds,
        }, (response) => {
          items.value = response.body.items;
        })
      }
    }
    const removeItem = function (idx) {
      items.value.splice(idx, 1);

      if (items.value.length === 0) {
        items.value.push({});
      }
    }

    watch(() => props.value, (newValue) => {
      items.value = newValue;
    }, {immediate: true});

    watch(() => items.value, (newValue) => {
      emit('input', newValue);
    }, {deep: true});

    return {
      items,
      getSubtotal,
      addItem,
      generateItemsFromBookings,
      removeItem,
    }
  },
}
</script>

<style lang="less">
.invoice-item-editor {
  height: 100%;

  display: flex;
  flex-direction: column;
  overflow: hidden;

  .invoice-item-header {
    flex: 0 0 auto;
    display: flex;
    gap: 12px;
  }

  .invoice-item-rows {
    flex: 1 1 0;
    overflow-y: auto;

    .invoice-item-row {
      display: flex;
      gap: 12px;
      margin-top: 12px;
    }
  }

  .invoice-item-item {
    flex: 2 2 0;
  }

  .invoice-item-unit-price {
    flex: 1 1 0;
  }

  .invoice-item-quantity {
    flex: 1 1 0;
  }

  .invoice-item-subtotal {
    flex: 1 1 0;
  }

  .invoice-item-delete {
    flex: 0 0 25px;
  }

  .invoice-items-summary {
    flex: 0 0 auto;
  }
}
</style>
